var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7787508DuplicateCopyDocumentsFolderFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    height: 200,
    id: "Layer_1",
    viewBox: "0 0 200 200",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145,17.5H90a30.09,30.09,0,0,0-30,30H55a30.09,30.09,0,0,0-30,30v75a30.09,30.09,0,0,0,30,30h55a30.09,30.09,0,0,0,30-30h5a30.09,30.09,0,0,0,30-30v-75a30.09,30.09,0,0,0-30-30Zm-25,135a10,10,0,0,1-10,10H55a10,10,0,0,1-10-10v-75a10,10,0,0,1,10-10h55a10,10,0,0,1,10,10Zm35-30a10,10,0,0,1-10,10h-5v-55a30.09,30.09,0,0,0-30-30H80a10,10,0,0,1,10-10h55a10,10,0,0,1,10,10v75Zm-55,10H65a10,10,0,0,0,0,20h35a10,10,0,0,0,0-20Zm0-30H65a10,10,0,0,0,0,20h35a10,10,0,0,0,0-20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7787508DuplicateCopyDocumentsFolderFileIcon);
export default __webpack_public_path__ + "static/media/7787508_duplicate_copy_documents_folder_file_icon.7943096f8082f9b2d25c24bef8aa5e72.svg";
export { ForwardRef as ReactComponent };